import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_ADJUSTMENT_REASON_CODES = "GET_ADJUSTMENT_REASON_CODES";

export const service = async (data) => {
  const options: object = {
    url: `/Api/CustomCARC/GetCARCMappingCodes/` + data.adjustmentCategoryId,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};
const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_ADJUSTMENT_REASON_CODES, service, mock);
